var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6.31543,
    width: 32,
    height: 23.5021,
    rx: 3.20764,
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 4.19087C4.45312 2.98089 5.43401 2 6.644 2H25.4324C26.6424 2 27.6233 2.98089 27.6233 4.19087H4.45312Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1185 20.7983L16.7726 25.1441C16.3837 25.533 15.7532 25.533 15.3643 25.1441L11.0184 20.7983C10.6295 20.4094 10.6295 19.7788 11.0184 19.3899C11.4073 19.001 12.0379 19.001 12.4268 19.3899L15.0726 22.0358L15.0726 11.4939C15.0726 10.9439 15.5185 10.498 16.0685 10.498C16.6184 10.498 17.0643 10.9439 17.0643 11.4939L17.0643 22.0358L19.7101 19.3899C20.099 19.001 20.7296 19.001 21.1185 19.3899C21.5074 19.7788 21.5074 20.4094 21.1185 20.7983Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImport);
export default __webpack_public_path__ + "static/media/ic_import.7602256d43dd8e5d700304860587bd91.svg";
export { ForwardRef as ReactComponent };